import React, { useState, useEffect } from 'react'
import useAxios from 'axios-hooks'
import { getAuthHeader } from 'utils/auth'
import { Modal, Form } from 'antd'
import { PageAlert, notificationToast, CreditList } from 'components'
import FormFooter from 'views/ScanSettings/components/ScanFilterBar/FormFooter'
import CreditsForm from 'views/Administration/Account/Credits/CreditsForm'
import AccountCreditsTop from 'views/Administration/Account/Credits/AccountCreditsTop'

const formKeys = {
  CREDITS: 'credits'
}

const AccountCredits = ({ form, name, id }) => {
  const [creditsData, setCreditsData] = useState({})
  const [creditsFormVisible, setCreditsFormVisible] = useState(false)

  // credits data
  const [{ data: listCreditsResponse, loading: listCreditsLoading, error: listCreditsError }, getCredits] = useAxios({
    url: `/administration/account/${id}/credits`,
    method: 'GET',
    headers: getAuthHeader(),
    validateStatus: false
  })

  // ADD Credits
  let [{ data: addCreditsData, loading: addingCredits, error: addCreditsError }, addCredits] = useAxios(
    {
      url: `/administration/account/credits`,
      method: 'POST',
      headers: getAuthHeader(),
      validateStatus: false
    },
    { manual: true }
  )

  const openNotification = (message, errors) => {
    if (!errors) {
      notificationToast({
        message: 'Success',
        description: message,
        icontype: 'check'
      })
    } else {
      notificationToast({
        message: 'Error',
        description: `${message} ${errors.join()}`,
        icontype: 'close-circle'
      })
    }
  }

  const onAddCredits = () => {
    setCreditsFormVisible(true)
  }

  // close Credits form
  const closeCreditsForm = () => {
    setCreditsFormVisible(false)
  }

  const onCreditsFormAfterClose = () => {
    form.resetFields()
  }

  // add credits
  const add = () => {
    form.validateFields((errors, values) => {
      if (!errors) {
        addCredits({
          data: {
            account_id: id,
            credits: values[formKeys.CREDITS]
          }
        })
      }
    })
  }

  // for list of credits
  useEffect(() => {
    if (listCreditsResponse) {
      setCreditsData(listCreditsResponse)
    }
  }, [listCreditsResponse])

  // for adding new credits
  useEffect(() => {
    if (addCreditsData) {
      if (addCreditsData.Errors) {
        const errorMessage = addCreditsData.Errors
        openNotification('Could not add credits.', errorMessage)
      } else {
        closeCreditsForm()
        openNotification('Credits were added successfully.')
        getCredits()
      }
    } else if (addCreditsError) {
      const errorMessage = addCreditsError?.response?.data?.Errors
      openNotification('Could not create domain.', errorMessage)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addCreditsData, addCreditsError, getCredits])

  return (
    <>
      {listCreditsError && <PageAlert message={listCreditsError} />}
      <AccountCreditsTop accountName={name} onAddCredits={onAddCredits} currentCredits={creditsData?.current} />
      <CreditList
        data={creditsData?.items}
        loading={listCreditsLoading}
        setCreditsFormVisible={setCreditsFormVisible}
      />
      <Modal
        title="Add Credits"
        width={380}
        visible={creditsFormVisible}
        closable={false}
        maskClosable={false}
        destroyOnClose={true}
        afterClose={onCreditsFormAfterClose}
        footer={<FormFooter onOK={add} onClose={closeCreditsForm} okText="ADD" confirmLoading={addingCredits} />}
      >
        <CreditsForm form={form} formKeys={formKeys} />
      </Modal>
    </>
  )
}

export default Form.create({})(AccountCredits)
